import { Fragment, useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import ProcessContext from '../../../../contexts/process/ProcessContext';
import UIContext from '../../../../contexts/ui/UIContext';
import StatusBarButton from '../../../layout/StatusBarButton';
import Loading from '../../../ui-elements/Loading';
import Channel from './Channel';
import Panel from './Panel';
import PlantBlockDiscardConfirm from './PlantBlockDiscardConfirm';

const ConfirmPanelDiscarding = ({ forwardTo, completingRef }) => {
  const { occupancyArray,activeProcessType, processTypes, loadOccupancy, activeProcessId, taskData, continueProcess, resetProcessState, additionalProcessInformation, finishProcess } =
    useContext(ProcessContext);
  const { loading, setInfo, clearInfo } = useContext(UIContext);
  const [confirmed, setConfirmed] = useState(false);

  useEffect(() => {
    if (additionalProcessInformation?.sourceEntity) {
      loadOccupancy(additionalProcessInformation.sourceEntity, 'panel');
    }
  }, []);
  useEffect(() => {
        clearInfo();
        let base = '';
        if (typeof activeProcessType === 'string') {
          base = activeProcessType;
        } else if (typeof activeProcessType === 'number') {
          const key = Object.keys(processTypes)
            .find(k => processTypes[k] === activeProcessType);
          base = key || '';
        }
        const processType = base ? camelCaseToWords(base) : '—';

        const panel = additionalProcessInformation?.sourceEntity || '—';

        const plants = Array.isArray(additionalProcessInformation?.sourceSelection)
          ? additionalProcessInformation.sourceSelection.length
          : 0;

        setInfo({ processType, panel, plants });
      }, [])

      function camelCaseToWords(str) {
        return str
          .replace(/([a-z])([A-Z])/g, '$1 $2') // Leerzeichen vor Großbuchstaben
          .replace(/ing$/i, '')                // "-ing" am Ende weg
          .toUpperCase();
      }

  const navigate = useNavigate();
  const confirmDiscarding = async () => {
    setConfirmed(true);
    try {
      await continueProcess(activeProcessId, true);
      if (completingRef) {
        completingRef.current = true;
        await finishProcess();
      }
      var processIsTaskDriven = taskData != null
      var redirectUrl = processIsTaskDriven ? taskData.redirectUrl : null;
      resetProcessState();
      if(processIsTaskDriven){
        if (redirectUrl){
          window.location.href = redirectUrl;
          return;
        }
        navigate('/', { state: { slide: 1 } });
        return;
      }
      else if (forwardTo) {
        navigate(forwardTo, { replace: true });
      }
    } catch (error) {
      console.error(error);
    }
  };
  return occupancyArray.length === 0 || (loading && confirmed) ? (
    <Loading fullScreen />
  ) : (
    <Fragment>
      <Panel>
        {occupancyArray.map((channel) => (
          <Channel key={channel.channelNumber} channel={channel}>
            {channel.plantSlotBlocks.map((block, index) => (
              <PlantBlockDiscardConfirm
                key={`${channel.channelNumber}-${block.startPlantSlotOrdinalNumber}-${block.endPlantSlotOrdinalNumber}`}
                block={block}
                channelNr={channel.channelNumber}
                index={index}
                disabled={!block.isOccupied}
                // TODO: Modify logic to determine if block is selected
                isSelected={
                  additionalProcessInformation?.sourceSelection?.includes(block.startPlantSlotOrdinalNumber) &&
                  block.isOccupied
                }
                style={{
                  height: (block.endPlantSlotOrdinalNumber - block.startPlantSlotOrdinalNumber + 1) / (parseInt(import.meta.env.VITE_PANELSETTINGS_TOTALPLANTSLOTSPERCHANNEL) / 100) + '%',
                }}
              />
            ))}
          </Channel>
        ))}
      </Panel>
      <StatusBarButton
        label='Confirm'
        icon='fas fa-check'
        reversed={true}
        clickHandler={confirmDiscarding}
        statusSlot={5}
      />
    </Fragment>
  );
};

export default ConfirmPanelDiscarding;
